import { createTypedAction } from "@app/utilities/ngrx";

const groupName = "OrderDetailCloneOrderModalActions";

const requestItemsAfterCloning = createTypedAction(
  groupName,
  "Request Items After Cloning",
);

export const OrderDetailCloneOrderModalActions = {
  requestItemsAfterCloning,
};
